// #region Imports
import { defineComponent, reactive } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-treeview-item',
    // #endregion
    // #region Properties
    props: {
        level: {
            type: Number,
            required: false,
            default: 0
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false
        },
        isExpanded: {
            type: Boolean,
            required: false,
            default: false
        },
        dataItem: {
            type: Object,
            required: false,
            default() {
                return reactive({
                    isExpanded: false,
                    isSelected: false,
                    caption: ''
                });
            }
        },
        getChildren: {
            type: Function,
            required: false,
        },
        hasChildren: {
            type: Function,
            required: false,
        },
    },
    // #endregion
    // #region Watch
    watch: {
        'label': function (value) {
            this.dataItem.caption = value;
        },
        'isSelected': function (value) {
            this.dataItem.isSelected = value;
        },
        'isExpanded': function (value) {
            this.dataItem.isExpanded = value;
        },
    },
    // #endregion
    // #region computed
    computed: {
        _linkUrl() {
            return this._hasChildren ? '' : (this.dataItem.actionCommand ? this.dataItem.actionCommand : 'to://' + this.dataItem.address);
        },
        _isExpanded() {
            return this._hasChildren && (this.dataItem?.isExpanded);
        },
        _isSelected() {
            return this.dataItem?.isSelected ?? false;
        },
        _hasChildren() {
            return !!this.$slots.children || ((this.hasChildren && this.dataItem) ? this.hasChildren(this.dataItem) : false);
        },
        nodes() {
            if (!this.getChildren || !this.dataItem) {
                return [];
            }
            return this.getChildren(this.dataItem);
        }
    },
    // #endregion
    // #region Methods
    methods: {
        onExpand() {
            this.dataItem.isExpanded = !this.dataItem.isExpanded;
        }
    }
    // #endregion
});
// #endregion
